import React from 'react'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'

@withGraphQL(
  gql`
    query usersCount($organization: String) {
      usersCount(organizationId: $organization)
    }
  `,
  {loading: <span> </span>}
)
export default class Counter extends React.Component {
  static propTypes = {
    usersCount: PropTypes.number,
    link: PropTypes.object
  }
  render() {
    return <span>{`(${this.props.usersCount[this.props.link.prop]})`}</span>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Organizations/Layout/counter.js